<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import logoNeurals from '../../assets/img/logo_neurals_nuevo.png' // Descomenta cuando tengas el logo real

const scrolled = ref(false)
const mobileMenuOpen = ref(false)

const handleScroll = () => {
  scrolled.value = window.scrollY > 30
}

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value
}

watch(mobileMenuOpen, (isOpen) => {
  document.body.style.overflow = isOpen ? 'hidden' : 'auto'
})

onMounted(() => window.addEventListener('scroll', handleScroll))
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
  document.body.style.overflow = 'auto'
})

// Estrategia PLG: Directo a la plataforma
const openApp = () => {
  window.open('https://app.neurals.pro', '_blank')
}
</script>

<template>
  <nav
    class="fixed top-0 left-0 w-full z-50 transition-all duration-300"
    :class="(scrolled || mobileMenuOpen)
      ? 'bg-neural-bg/80 backdrop-blur-xl py-3.5 md:py-4 border-b border-neural-border shadow-lg'
      : 'bg-transparent py-5 md:py-7 border-transparent'"
  >
    <div class="container mx-auto px-6 lg:px-12 flex justify-between items-center">

      <!-- Logo Neurals.pro -->
      <a href="#" class="flex items-center gap-2 hover:opacity-80 transition-opacity z-50">
        <img :src="logoNeurals" alt="Neurals Logo" class="h-8 md:h-9 w-auto object-contain brightness-0 invert">
      </a>

      <!-- Enlaces de Navegación (Escritorio) -->
      <div class="hidden lg:flex space-x-8 text-neural-muted text-sm font-medium tracking-wide items-center">
        <!-- Anchors reales conectados a los IDs de tus secciones -->
        <a href="#capacidades" class="hover:text-neural-text transition-colors duration-200">Despliegue</a>
        <a href="#captura" class="hover:text-neural-text transition-colors duration-200">Casos de Uso</a>
        <!-- <a href="#faq" class="hover:text-neural-text transition-colors duration-200">FAQs</a> -->
      </div>

      <!-- Acciones Derecha -->
      <div class="flex items-center gap-3 z-50">
        <!-- Botón Principal (PLG - Directo a App) -->
        <button
          @click="openApp"
          class="hidden sm:flex px-5 py-2.5 rounded-xl bg-neural-primary hover:bg-neural-primary-hover text-white text-xs sm:text-sm font-semibold tracking-wide transition-all duration-300 shadow-glow-primary hover:shadow-[0_0_20px_rgba(99,102,241,0.6)] items-center gap-2 transform hover:-translate-y-0.5"
        >
          <span>Probar Gratis</span>
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>

        <!-- Hamburguesa Móvil -->
        <button
          @click="toggleMobileMenu"
          class="lg:hidden flex items-center justify-center h-10 w-10 rounded-xl bg-neural-card border border-neural-border text-neural-text hover:bg-[#27272A] transition-colors focus:outline-none"
          aria-label="Abrir menú"
        >
          <svg v-if="mobileMenuOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

    </div>

    <!-- MENÚ MÓVIL (Oscuro SaaS) -->
    <Transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="opacity-0 -translate-y-4"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-4"
    >
      <div
        v-if="mobileMenuOpen"
        class="lg:hidden fixed inset-x-0 top-[68px] md:top-[76px] bg-neural-bg/95 backdrop-blur-xl border-b border-neural-border shadow-2xl px-6 py-8 max-h-[calc(100vh-70px)] overflow-y-auto"
      >
        <div class="flex flex-col space-y-5 text-sm font-semibold text-neural-muted tracking-wide">

          <a href="#capacidades" @click="mobileMenuOpen = false" class="hover:text-neural-primary border-b border-neural-border pb-3 flex items-center justify-between">
            <span>CÓMO FUNCIONA</span>
            <span class="text-[10px] bg-neural-primary/10 border border-neural-primary/30 text-neural-primary px-2 py-0.5 rounded font-extrabold uppercase">Despliegue</span>
          </a>
          <a href="#captura" @click="mobileMenuOpen = false" class="hover:text-neural-text border-b border-neural-border pb-3">CASOS DE USO</a>

          <div class="pt-4">
            <button
              @click="openApp"
              class="w-full py-3.5 rounded-xl bg-neural-primary text-white font-semibold text-sm shadow-glow-primary transition-all text-center flex justify-center gap-2 items-center"
            >
              <span>Iniciar Prueba Gratis</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          </div>

        </div>
      </div>
    </Transition>
  </nav>
</template>